<div class="popup-container" *ngIf="isPopupVisible">
  <div class="popup-wrapper" [id]="popupId">
    <div class="pop-up">
      <span class="close-button" (click)="closePopup()">x</span>
      <a [href]="redirectUrl" target="_blank">
        <img [src]="imageUrl" alt="Popup Image" />
      </a>
    </div>
  </div>
</div>
